
import React from 'react';

import { useAnnotation, useStore } from '../../../hooks';
import { TOOLS_IDS } from '../../../utils/constants';
import ImageControls from './ImageControls';

const ImageOptions = () => {
  const { t } = useStore();

  const [image, saveImage] = useAnnotation(
    {
      name: TOOLS_IDS.IMAGE,
      opacity: 1,
    },
    false,
  );

  return <ImageControls image={image} saveImage={saveImage} t={t} />;
};

export default ImageOptions;
